import { BaseText, Headline3, Meta, theme } from 'aimo-ui';
import TouchableItem from 'components/common/TouchableItem';
import Icon from 'components/icons/Icon';
import useSelectCityPmc from 'hooks/useSelectCityPmc';
import React from 'react';
import styled from 'styled-components/native';
import { ColumnWithMargins } from 'styles/ContainerStyles';
import { Maybe, Pmc } from 'types/generatedSchemaTypes';
import { getMonthlyPrice } from 'utils/cityParkingUtils';
import { testIdentifiers } from 'utils/testIdentifiers';
import { IconWrapper, Row } from '../styles/styles';

const ItemRow = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const ContentColumn = styled.View`
  flex: 1;
  flex-direction: column;
  gap: 5px;
`;

const CityParkingSelectItem: React.FC<{
  item: Maybe<Pmc>;
  canPurchase: boolean;
}> = ({ item: pmcItem }) => {
  const { id, name, prices, countryCode, physicalZoneUid, parkZone } =
    pmcItem ?? {};
  const zoneCode = parkZone?.commercialZoneView?.zoneCode;

  const { onItemSelect } = useSelectCityPmc();
  const priceString = getMonthlyPrice(prices, countryCode);

  return (
    <TouchableItem
      onPress={() => onItemSelect(physicalZoneUid)}
      testID={`city-pmcs-search-item-${id}`}>
      <ItemRow>
        <ContentColumn>
          <Row mt={0} mb={0}>
            {zoneCode && (
              <ColumnWithMargins mr={5}>
                <BaseText
                  color={theme.colors.boost.green}
                  {...testIdentifiers('city-pmcs-search-item-zone-code')}>
                  {zoneCode}
                </BaseText>
              </ColumnWithMargins>
            )}
            <Headline3 numberOfLines={1} testID="city-pmcs-search-item-name">
              {name}
            </Headline3>
          </Row>
          <Row mt={0} mb={0}>
            <IconWrapper mr={10}>
              <Icon size="s" name="Service-Filled" />
            </IconWrapper>
            <Meta testID="city-pmc-item-price" color={theme.colors.gray200}>
              {priceString}
            </Meta>
          </Row>
        </ContentColumn>
        <ColumnWithMargins ml={10}>
          <Icon name="Chevron_Right" />
        </ColumnWithMargins>
      </ItemRow>
    </TouchableItem>
  );
};

export default CityParkingSelectItem;
